var map = {
	"./approved.svg": 506,
	"./arrow-blue.svg": 643,
	"./arrow-down.svg": 501,
	"./arrow.svg": 25,
	"./arrowBackwards.svg": 172,
	"./arrowBlue.svg": 636,
	"./back-arrow.svg": 449,
	"./bell-icon.svg": 1132,
	"./blue.svg": 1133,
	"./change-password.svg": 1134,
	"./chasingstats.svg": 1135,
	"./close-icon.svg": 558,
	"./close.svg": 123,
	"./closeIcon.svg": 296,
	"./dashboard-new/filter-clear.svg": 649,
	"./dashboard-new/graph1.svg": 653,
	"./dashboard-new/graph2.svg": 654,
	"./dashboard-new/graph3.svg": 655,
	"./dashboard-new/graph4.svg": 656,
	"./dashboard-new/long-arrow.svg": 511,
	"./dashboard-new/menu.svg": 553,
	"./dashboard.svg": 447,
	"./dd-arrow.svg": 21,
	"./deemed.svg": 508,
	"./doc.svg": 221,
	"./document.svg": 1136,
	"./edit.svg": 222,
	"./efficency_circle.svg": 635,
	"./equalizer.svg": 357,
	"./expandIcon.svg": 1137,
	"./fire-extinguisher.svg": 645,
	"./flag-deemed.svg": 1138,
	"./flag-green.svg": 1139,
	"./flag-orange.svg": 1140,
	"./flag-red.svg": 1141,
	"./graph.svg": 241,
	"./green.svg": 1142,
	"./growth-icon.svg": 1143,
	"./growth.svg": 448,
	"./id.svg": 1144,
	"./irrigation.svg": 644,
	"./leftarrow.svg": 223,
	"./logout.svg": 554,
	"./mail.svg": 640,
	"./mail_active.svg": 639,
	"./more.svg": 1145,
	"./notSuccess.svg": 509,
	"./orange.svg": 1146,
	"./password.svg": 499,
	"./pdf.svg": 152,
	"./plus.svg": 356,
	"./police.svg": 646,
	"./print.svg": 1147,
	"./raise_shortfall.svg": 1148,
	"./received.svg": 505,
	"./red.svg": 1149,
	"./rejected.svg": 507,
	"./report.svg": 1150,
	"./rupee-circle.svg": 1151,
	"./rupee.svg": 1152,
	"./scrutinity.svg": 555,
	"./search.svg": 358,
	"./sms.svg": 638,
	"./sms_active.svg": 637,
	"./success-grey.svg": 1153,
	"./success.svg": 169,
	"./successDarkGreen.svg": 510,
	"./successLightGreen.svg": 502,
	"./tax.svg": 1154,
	"./technical-support.svg": 1155,
	"./tick.svg": 633,
	"./tick_1.svg": 642,
	"./user-alt-1-svgrepo-com.svg": 1156,
	"./v-down-active.svg": 1157,
	"./v-down-inactive.svg": 504,
	"./v-down.svg": 1158,
	"./verification-active.svg": 1159,
	"./verification.svg": 1160,
	"./watch.svg": 1161
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 657;